var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-card",
        { staticClass: "item-translation-languages-dialog" },
        [
          _c("v-card-title", [
            _c("span", { staticClass: "headline" }, [
              _vm._v(
                _vm._s(_vm.$t("front.item_translation_languages.modal_title"))
              )
            ]),
            _c("span", { staticClass: "close", on: { click: _vm.close } }, [
              _c(
                "svg",
                {
                  attrs: {
                    width: "14",
                    height: "14",
                    viewBox: "0 0 14 14",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                  }
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M1 1L13 13",
                      stroke: "white",
                      "stroke-width": "2"
                    }
                  }),
                  _c("path", {
                    attrs: {
                      d: "M13 1L1 13",
                      stroke: "white",
                      "stroke-width": "2"
                    }
                  })
                ]
              )
            ])
          ]),
          _c(
            "v-card-text",
            [
              _c("h3", [
                _vm._v(
                  _vm._s(_vm.$t("front.item_translation_languages.header"))
                )
              ]),
              _c("p", [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "front.item_translation_languages.available_translations"
                    )
                  )
                )
              ]),
              _vm._l(_vm.allowedLocales, function(allowedLocale, index) {
                return _vm.localeTitle(allowedLocale)
                  ? _c(
                      "div",
                      {
                        key: index,
                        staticClass: "item-translation-language",
                        on: {
                          click: function($event) {
                            return _vm.changePageLocale(allowedLocale)
                          }
                        }
                      },
                      [
                        _c(
                          "router-link",
                          { attrs: { to: _vm.localeRoute(allowedLocale) } },
                          [
                            _vm._v(
                              _vm._s(_vm.localeTitle(allowedLocale)) +
                                "\n                "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e()
              })
            ],
            2
          ),
          _c(
            "v-card-actions",
            [
              _c(
                "v-btn",
                { staticClass: "btn-success", on: { click: _vm.goToMainPage } },
                [
                  _vm._v(
                    _vm._s(
                      _vm.$t("front.item_translation_languages.to_main_page")
                    )
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }